<offconon-shared-ui-virtualscroll-dropdown
  [selectOptions]="(siUnitList$ | async) || []"
  [selectedOption]="$any(commonDropdownAndMultiselectService.selectedOptions$) | async"
  (selectedOptionOutput)="select($event)"
  (paginationAndSearchOutput)="paginationAndSearchOutput($event)" />
